const state = {
    userInfo:{
    },  // 播放数据
};
const mutations ={
    mSetUsetInfo(state,data){
        state.userInfo = data;
    }
};
const getters = {
    gUserInfo(state){
        return state.userInfo
    }
};
const actions = {
    aUserInfo(context,data){
        context.commit('mSetUsetInfo',data)
    }
};
export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/other.js